module.exports = __webpack_public_path__ + "static/media/passport.e84c11a9.jpg";